// removed by extract-text-webpack-plugin
module.exports = {"Spinner":"Spinner","Spinning":"Spinning","Logo":"Logo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Spinner/styles.scss
// module id = 1131
// module chunks = 10